import * as React from "react";
import "./billingEstimatePage.scss";
import BillingEstimateStepper from "@app/preBill/components/billingEstimateStepper";

const BillingEstimatePage: React.FC = () => {
  return <BillingEstimateStepper />;
};

export default BillingEstimatePage;
